sb.AutoCompleteArchiveOption = class extends u.AutoCompleteOption {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this.style.display = 'block';
        this.style.overflowX =  'hidden';
        this.style.textOverflow = 'ellipsis';
        this.style.whiteSpace = 'nowrap';

        this.style.cursor = 'default';
        this.style.wordWrap = 'break-word';
        this.style.textAlign = 'center';
        this.style.whiteSpace = 'normal';
        this.appendChild(document.createTextNode("Not seeing what you're looking for? Check the "));

        let a = document.createElement('a');
        a.style.cursor = 'pointer';
        a.style.color = '#05A2D6';
        a.innerText = 'Archived Apps';
        a.href = '/archive/apps/#/order/popular';
        this.appendChild(a);
        this.appendChild(document.createTextNode(' page.'));

        this.$parent = null;

        this._mouseEnter = (evt) => {
            if (evt.button === 0) {
                const highlighted = this.$parent.$highlighted();
                if (highlighted) {
                    highlighted.classList.remove(this.$parent.$highlightClass);
                }
            }
        };
    }

    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('mouseenter', this._mouseEnter);
    }

    detachedCallback() {
        super.detachedCallback();
        this.removeEventListener('mouseenter', this._mouseEnter);
    }
};

sb.AutoCompleteArchiveOption.register('sb-autocomplete-archive-option');

sb.AutoComplete = class extends u.AutoComplete {
    /**
     *
     */
    createdCallback() {
        super.createdCallback();
        this._mouseDown = (evt) => {
            if (evt.button === 0) {
                let elem = evt.target;
                while (elem) {
                    if (elem instanceof u.AutoCompleteOption) {
                        this.$select(elem.$value);
                        return;
                    }
                    if (elem.href) {
                        window.location = elem.href;
                        return;
                    }
                    elem = elem.parentElement;
                }
            } else {
                evt.preventDefault();
            }
        };
    };

    $input(value) {
        /**
         * 
         */
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
            this.$update(value, JSON.parse(xhr.responseText).results);
        };
        xhr.open('GET', '/api/v1/search/autocomplete/?q=' + value + '&archiving=false', true);
        xhr.send();
    };

    $update(value, options) {
        if (this._latestValue === value) {

            // remove old nodes
            let child;
            while (child = this.firstChild) {
                this.removeChild(child);
            }

            if (options.length) {
                options.forEach((value) => {
                    const elem = document.createElement('u-autocomplete-option');
                    elem.$value = value;
                    elem.$parent = this;
                    this.$add(elem, value);
                    this.appendChild(elem);
                });

                const archive_elem = document.createElement('sb-autocomplete-archive-option');
                archive_elem.$parent = this;
                this.appendChild(archive_elem);
                this.$show();
            }
        }
    };

    $add(elem, value) {
        /**
         *
         */
        const img = document.createElement('img');
        const span = document.createElement('span');
        img.src = value.icon_url;
        span.textContent = value.name;
        elem.appendChild(img);
        elem.appendChild(span);
    };

    $select(value) {
        if (value) {
            window.location = '/app/' + value.pk + '/';
        }
    };

    $search(value) {
        value = encodeURI(value);
        window.location = '/apps/#/search/' + value + '/';
    };

    // _boldSpan(title) {
    //     /**
    //      * TODO: New designs don't have this, but I'm keeping for now because you never know.
    //      */
    //     const span = document.createElement('span');
    //     const re = new RegExp(this.input.value.split(' ').filter(function (val) {
    //         return !!val;
    //     }).join('|'), 'ig');
    //
    //     const highlight = [];
    //
    //     let counter = 0;
    //     let match;
    //     let content;
    //     let node;
    //
    //     while ((match = re.exec(title)) !== null) {
    //         highlight.push({start: match.index, length: match[0].length});
    //     }
    //
    //     for (let i = 0; i < highlight.length; i++) {
    //         let start = highlight[i].start;
    //         let length = highlight[i].length;
    //
    //         content = title.slice(counter, start);
    //         node = document.createTextNode(content);
    //         span.appendChild(node);
    //
    //         content = title.substr(start, length);
    //         node = document.createElement('strong');
    //         node.textContent = content;
    //         span.appendChild(node);
    //
    //         counter = start + length;
    //     }
    //
    //     content = title.substr(counter, title.length - counter);
    //     node = document.createTextNode(content);
    //     span.appendChild(node);
    //
    //     return span;
    // }
};

sb.AutoComplete.register('sb-autocomplete');
